export default {
  title: 'Szablon wiadomości',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'schema.mailTemplate.name',
      fieldRequired: true,
      maxLength: 500
    },
    subject: {
      type: 'string',
      title: 'schema.mailTemplate.subject',
      fieldRequired: true,
      maxLength: 500
    },
    fromAddress: {
      type: 'string',
      title: 'schema.mailTemplate.fromAddress',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Pole musi być adresem e-mail.'
      }
    },
    fromName: {
      type: 'string',
      title: 'schema.mailTemplate.fromName',
      fieldRequired: true,
      maxLength: 500
    },
    to: {
      type: 'string',
      title: 'schema.mailTemplate.to',
      fieldRequired: false,
      maxLength: 500
    },
    body: {
      type: 'string',
      title: 'schema.mailTemplate.body',
      fieldRequired: true
    }
  }
};
